import { CdkDragDrop, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MenuModalComponent } from '../menu-modal/menu-modal.component'; // გზა სწორად მიუთითე
import { MenuService } from 'src/app/services/menu/menu.service';
import { environment } from 'src/environments/environment';
import { AdminService } from 'src/app/services/admin/admin.service';
@Component({
  selector: 'app-menu-item',
  imports: [CommonModule, FormsModule, DragDropModule],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.css'
})
export class MenuItemComponent {
  @Input() item!: any;
  @Input() allMenu: any[] = [];
  @Output() update = new EventEmitter<void>();
  @Output() deleted = new EventEmitter<number>();

  showChildren = false;
  isTogglingVisible = false;

  @Output() dragChanged = new EventEmitter<boolean>();

  constructor(
    private modalService: NgbModal,
    private menuService: MenuService,
    public admin: AdminService
    
  ) {}
  
  // addChild() {
  //   const newChild = {
  //     id: Date.now(), // დროებითი ID
  //     title: 'ახალი ქვეპუნქტი',
  //     children: [] as any[]
  //   };
  //   this.item.children.push(newChild);
  //   this.update.emit();
  // }

  deleteItem() {
    const id = Number(this.item?.id);
    if (!id) return;

    // მარტივი confirm (შენ შეგიძლია მერე NgbModal confirm-ით შეცვალო)
    const ok = window.confirm('დარწმუნებული ხარ რომ გინდა ამ მენიუს წაშლა? (ქვე-მენიუებიც წაიშლება)');
    if (!ok) return;

    this.menuService.deleteMenuItem(id).subscribe({
      next: () => {
        // UI: მოვაშოროთ ელემენტი ლოკალურად, რომ რეფრეში არ დასჭირდეს
        // ამ კომპონენტში allMenu არის მთელი ხე (root list), ამიტომ აქედან ამოვშალოთ
        this.removeNodeById(this.allMenu, id);

        // notify parent
        this.deleted.emit(id);
        this.update.emit();
      },
      error: (err) => {
        console.error('[MenuItem] delete failed', err);
        alert('წაშლა ვერ შესრულდა');
      }
    });
  }

  toggleVisible() {
    const id = Number(this.item?.id);
    if (!id || this.isTogglingVisible) return;

    // toggle current value (backend expects 0/1)
    const nextVisible = Number(this.item?.visible) === 1 ? 0 : 1;

    this.isTogglingVisible = true;

    // Use existing update endpoint (FormData + _method=PUT)
    const fd = new FormData();
    fd.append('_method', 'PUT');

    // Backend validation may require title even for partial updates.
    // Send current title so the request passes validation.
    const currentTitle = String(this.item?.title ?? this.item?.menutitle ?? '').trim();
    if (currentTitle) {
      fd.append('title', currentTitle);
    }

    // Some backends also validate status/pos; include safe defaults if present on the item.
    if (this.item?.status !== undefined && this.item?.status !== null) {
      fd.append('status', String(this.item.status));
    }
    if (this.item?.pos !== undefined && this.item?.pos !== null) {
      fd.append('pos', String(this.item.pos));
    }

    fd.append('visible', String(nextVisible));

    this.menuService.updateMenuItem(id, fd).subscribe({
      next: () => {
        // optimistic UI update
        this.item.visible = nextVisible;
        this.isTogglingVisible = false;
        this.update.emit();
      },
      error: (err) => {
        console.error('[MenuItem] toggle visible failed', err);
        this.isTogglingVisible = false;
        alert('ვერ მოხერხდა დამალვა/ჩართვა');
      }
    });
  }

  canHaveLink(item: any): boolean {
  // თუ ქვე-მენიუები აქვს და dropdown-ია → ბმული არ აქვს
  if (item.children?.length > 0 && item.visible_sub_menu !== 1) {
    return false;
  }

  // თუ აქვს url ან page → შეიძლება ბმული
  return !!item.url || !!item.page;
}

openLink(item: any) {
  const target = item.target || '_self';
    console.log('11',  item)
    // return;
  // 1. External absolute URL (http / https)
  if (item.url && /^https?:\/\//i.test(item.url)) {
    window.open(item.url, target);
    return;
  }

  // 2. Relative URL -> prepend defaultDomain
  // if (item.url) {
  //   const domain = environment.defaultDoamin.replace(/\/$/, '');
  //   const path = item.url.startsWith('/') ? item.url : `/${item.url}`;
  //   window.open(`${domain}${path}`, target);
  //   return;
  // }

  // 3. Internal page (menu_page)
  if (item.page_type_id == 1) {
    const domain = environment.defaultDoamin.replace(/\/$/, '');
    window.open(`${domain}/page/${item.page}`, '_blank');
  }

  if (item.page_type_id == 36) {
    const domain = environment.defaultDoamin.replace(/\/$/, '');
    window.open(`${domain}/list/${item.page}`, '_blank');
  }

  if (item.page_type_id == 40) {
    const domain = environment.defaultDoamin.replace(/\/$/, '');
    window.open(`${domain}/gallery/${item.page}`, '_blank');
  }

  if (item.page_type_id == 8) {
    const domain = environment.defaultDoamin.replace(/\/$/, '');
    window.open(`${domain}/form/${item.page}`, '_blank');
  }
  if (item.page_type_id == 35) {
    const domain = environment.defaultDoamin.replace(/\/$/, '');
    window.open(`${domain}/faq/${item.page}`, '_blank');
  }

}
dropChild(event: CdkDragDrop<any[]>) {
  // გადაადგილება children-ის მასივში
  this.item.children = this.item.children ?? [];
  moveItemInArray(this.item.children, event.previousIndex, event.currentIndex);

  // დაემატოს ახალი sort value
  this.item.children.forEach((child: any, index: number) => {
    child.sort = index + 1;
  });


  // notify parent component that drag has changed (enable "Save structure" button)
  this.dragChanged.emit(true);

  // DO NOT auto-reload/save here. Saving should be triggered only by the user (Save button).
}

  private normalizeTarget(val: any): '_self' | '_blank' {
    // backend sometimes stores 0/1/null
    if (val === 1 || val === '1' || val === '_blank') return '_blank';
    return '_self';
  }

  /**
   * Find a node by id anywhere in the tree.
   */
  private findNodeById(list: any[], id: number): any | null {
    for (const n of list ?? []) {
      if (Number(n?.id) === id) return n;
      const children = (n?.children ?? []) as any[];
      const hit = this.findNodeById(children, id);
      if (hit) return hit;
    }
    return null;
  }

  /**
   * Remove a node from the tree and return the SAME object reference.
   * This is the key to updating the UI without reloading from backend.
   */
  private removeNodeById(list: any[], id: number): any | null {
    if (!Array.isArray(list)) return null;

    const idx = list.findIndex(x => Number(x?.id) === id);
    if (idx >= 0) {
      const [removed] = list.splice(idx, 1);
      return removed ?? null;
    }

    for (const n of list) {
      const children = (n?.children ?? []) as any[];
      const removed = this.removeNodeById(children, id);
      if (removed) return removed;
    }

    return null;
  }

  /**
   * Insert node under parentId. If parentId is 0/null -> insert to root.
   */
  private insertNode(list: any[], parentId: number, node: any): void {
    // root insert
    if (!parentId || parentId === 0) {
      list.push(node);
      return;
    }

    const parent = this.findNodeById(list, parentId);
    if (!parent) {
      // fallback: if parent not found in current tree, keep it at root
      list.push(node);
      return;
    }

    parent.children = parent.children ?? [];
    parent.children.push(node);
  }

  /**
   * Move item in the in-memory menu tree when parent changes.
   */
  private moveInTree(root: any[], id: number, newParentId: number): void {
    const node = this.removeNodeById(root, id);
    if (!node) return;

    // ensure children exists so template never crashes
    node.children = node.children ?? [];

    this.insertNode(root, newParentId, node);
  }

  openAddChildModal() {
    const modalRef = this.modalService.open(MenuModalComponent, { size: 'lg' });

    // create child under current item
    modalRef.componentInstance.menuItem = {
      menutitle: '',
      visibility: 1,
      // IMPORTANT: backend expects parent as up_id / parent_id
      parent_id: this.item?.id,
      up_id: this.item?.id,
      // keep same position/pos as parent so it appears in the same section
      position: this.item?.pos ?? this.item?.position ?? 2,
      pos: this.item?.pos ?? this.item?.position ?? 2,
      // defaults
      status: 1,
      visible: 1,
      show_menu: 0,
      visible_sub_menu: 0,
      isRedirect: 0,
      url: '',
      target: this.normalizeTarget(this.item?.target),
    };

    // Pass full menu list so parent select & filtering work
    modalRef.componentInstance.allMenu = this.allMenu;

    modalRef.result
      .then((createdChild: any) => {
        if (!createdChild) return;

        // ensure children array exists
        this.item.children = this.item.children ?? [];
        createdChild.children = createdChild.children ?? [];

        // push into THIS item's children (not into root)
        this.item.children.push(createdChild);

        // expand parent so it becomes visible immediately
        this.showChildren = true;

        // notify parent component (parent will reload / refresh)
        this.update.emit();
      })
      .catch(() => {});
  }

  openEditModal() {
    const modalRef = this.modalService.open(MenuModalComponent, { size: 'lg' });

    modalRef.componentInstance.menuItem = { ...this.item };

    // Pass full menu list if needed
    modalRef.componentInstance.allMenu = this.allMenu;

    modalRef.result
      .then((result) => {
        if (!result) return;

        // Minimal: do not try to patch/move the tree in-memory.
        // Parent will handle refresh/reload.
        this.update.emit();
      })
      .catch(() => {});
  }



  
  


}
